/* ════════════════════════════════════════════════════════════════════
   sk-giftcard.js — Gift Card PDP
   One option dimension (Denominations) -> one pill per variant.
   Posts the real form as FormData to /cart/add.js so Shopify's native
   gift-card recipient line-item properties ride along untouched.
   Cart add fires the site cart-drawer events (sk-cart:added), same API
   as sk-meal.js / sk-apparel.js.

   Recipient contract (mirrors Shopify Dawn's recipient-form.js):
     - checkbox ships `disabled`; we enable it (proves JS is alive)
     - hidden "if_present" control ships enabled; we DISABLE it and hand
       control to the checkbox
     - recipient fields ship `disabled`; enabled only while checked, so
       FormData never carries empty recipient properties
     - __shopify_offset carries the browser's timezone offset so a
       "Send on" date lands on the right day in NZ, not UTC
   ════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var root = document.querySelector(".sk-giftcard-buy");
  if (!root) return;

  var $  = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var money = function (cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.theme && theme.moneyFormat);
    return "$" + (cents / 100).toFixed(2);
  };

  var form     = $("#sk-giftcard-form");
  var idInput  = $("[data-sk-gc-id]");
  var priceEl  = $("[data-sk-gc-price]");
  var addBtn   = $("[data-sk-gc-add]");
  var addLabel = $("[data-sk-gc-addlabel]");
  var formErr  = $("[data-sk-gc-formerr]");
  var addText  = addLabel ? addLabel.textContent : "Add to bag";

  /* ── denominations ── */
  $$("[data-sk-gc-variant]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (btn.disabled) return;
      $$("[data-sk-gc-variant]").forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      if (idInput) idInput.value = btn.getAttribute("data-sk-gc-variant");
      var priceText = btn.textContent.trim();
      if (priceEl && priceText) priceEl.textContent = priceText;
      var media = btn.getAttribute("data-media");
      if (media) activateFrame(media);
      clearErrors();
    });
  });

  /* ── gallery ── */
  function activateFrame(mediaId) {
    var frames = $$("[data-sk-gc-gallery] .gc-frame");
    var target = frames.filter(function (f) { return f.getAttribute("data-media-id") === mediaId; })[0];
    if (!target) return;
    frames.forEach(function (f) { f.classList.remove("active"); });
    target.classList.add("active");
    $$("[data-sk-gc-thumb]").forEach(function (t) { t.classList.toggle("on", t.getAttribute("data-sk-gc-thumb") === mediaId); });
  }
  $$("[data-sk-gc-thumb]").forEach(function (t) {
    t.addEventListener("click", function () { activateFrame(t.getAttribute("data-sk-gc-thumb")); });
  });

  /* ── recipient form ── */
  var recip     = $("[data-sk-gc-recip]");
  var cb        = $("[data-sk-gc-recip-cb]");
  var control   = $("[data-sk-gc-recip-control]");
  var offset    = $("[data-sk-gc-recip-offset]");
  var liveRegion = recip ? $(".gc-recip__live", recip) : null;
  var recipFields = [];

  if (recip && cb) {
    recipFields = [
      $("[data-sk-gc-recip-email]"),
      $("[data-sk-gc-recip-name]"),
      $("[data-sk-gc-recip-message]"),
      $("[data-sk-gc-recip-sendon]")
    ].filter(Boolean);

    // JS is alive: the checkbox becomes the control, the no-JS fallback stands down.
    cb.disabled = false;
    if (control) control.disabled = true;
    if (offset) offset.value = new Date().getTimezoneOffset().toString();

    cb.addEventListener("change", onRecipChange);
    onRecipChange();

    // A "Send on" date in the past is rejected at checkout; stop it at the source.
    var sendon = $("[data-sk-gc-recip-sendon]");
    if (sendon) {
      var t = new Date();
      sendon.min = [
        t.getFullYear(),
        String(t.getMonth() + 1).padStart(2, "0"),
        String(t.getDate()).padStart(2, "0")
      ].join("-");
    }

    // character counter
    var msg = $("[data-sk-gc-recip-message]");
    var count = $("[data-sk-gc-count]");
    if (msg && count) {
      var max = msg.getAttribute("maxlength") || 200;
      var sync = function () { count.textContent = msg.value.length + "/" + max; };
      msg.addEventListener("input", sync);
      sync();
    }
  }

  function onRecipChange() {
    var on = cb.checked;
    // Disabled fields are not serialised into FormData — that is what keeps empty
    // recipient properties off the line item when the box is unticked.
    recipFields.forEach(function (f) {
      f.disabled = !on;
      if (!on) { f.value = ""; f.removeAttribute("aria-invalid"); }
    });
    if (offset) offset.disabled = !on;
    if (!on) clearErrors();
    var msgEl = $("[data-sk-gc-count]");
    if (!on && msgEl) msgEl.textContent = "0/200";
    if (liveRegion) liveRegion.textContent = on ? "Gift details shown." : "Gift details hidden.";
  }

  /* ── errors ── */
  function clearErrors() {
    if (formErr) { formErr.hidden = true; formErr.textContent = ""; }
    $$("[data-sk-gc-err]").forEach(function (el) { el.hidden = true; el.textContent = ""; });
    recipFields.forEach(function (f) { f.removeAttribute("aria-invalid"); });
  }

  function fieldFor(key) {
    if (key === "email")   return $("[data-sk-gc-recip-email]");
    if (key === "name")    return $("[data-sk-gc-recip-name]");
    if (key === "message") return $("[data-sk-gc-recip-message]");
    if (key === "send_on") return $("[data-sk-gc-recip-sendon]");
    return null;
  }

  function showErrors(payload) {
    clearErrors();
    var errors = payload && payload.errors;
    var handled = false;

    // Shopify returns per-field errors for the recipient form, e.g. { email: ["is invalid"] }
    if (errors && typeof errors === "object" && !Array.isArray(errors)) {
      Object.keys(errors).forEach(function (key) {
        var el = $('[data-sk-gc-err="' + key + '"]');
        var input = fieldFor(key);
        var msg = errors[key];
        if (Array.isArray(msg)) msg = msg.join(", ");
        if (el && msg) {
          el.textContent = String(msg).charAt(0).toUpperCase() + String(msg).slice(1);
          el.hidden = false;
          handled = true;
          if (input) input.setAttribute("aria-invalid", "true");
        }
      });
      var first = $('[data-sk-gc-err]:not([hidden])');
      if (first) {
        var focusKey = first.getAttribute("data-sk-gc-err");
        var focusEl = fieldFor(focusKey);
        if (focusEl) focusEl.focus();
      }
    }

    if (!handled && formErr) {
      formErr.textContent = (payload && (payload.description || payload.message)) || "Something went wrong. Please try again.";
      formErr.hidden = false;
    }
  }

  /* ── toast ── */
  var toast = $("[data-sk-gc-toast]");
  var toastTimer = null;
  function showToast(msg) {
    if (!toast) return;
    var m = $("[data-sk-gc-toastmsg]"); if (m && msg) m.textContent = msg;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 3000);
  }

  /* ── add to bag ── */
  function doAdd() {
    if (!form) return;
    clearErrors();

    // Client-side gate: an email is the one thing Shopify genuinely needs to send it.
    if (cb && cb.checked) {
      var email = $("[data-sk-gc-recip-email]");
      if (email && !email.value.trim()) {
        var el = $('[data-sk-gc-err="email"]');
        if (el) { el.textContent = "Add their email so we know where to send it."; el.hidden = false; }
        email.setAttribute("aria-invalid", "true");
        email.focus();
        return;
      }
    }

    if (addBtn) { addBtn.classList.add("loading"); addBtn.disabled = true; }

    var body = new FormData(form);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/javascript", "X-Requested-With": "XMLHttpRequest" },
      body: body
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function () {
        if (cb && cb.checked) { cb.checked = false; onRecipChange(); }
        showToast("Added to your bag");
        document.dispatchEvent(new CustomEvent("sk-cart:added", { detail: { open: true } }));
      })
      .catch(function (e) {
        showErrors(e);
      })
      .then(function () {
        if (addBtn) { addBtn.classList.remove("loading"); addBtn.disabled = false; }
        if (addLabel) addLabel.textContent = addText;
      });
  }

  if (form) form.addEventListener("submit", function (e) { e.preventDefault(); doAdd(); });

  /* ── closing band CTA — scroll back to the buy block, don't add blind ──
     The buyer still needs the amount + gift options, so a one-tap add here
     would quietly skip them. Lives outside `root`, hence the document query. */
  var finalBtn = document.querySelector("[data-sk-gc-final]");
  if (finalBtn) {
    finalBtn.addEventListener("click", function () {
      var target = $(".gc-buy-col") || root;
      if (window.skScrollToEl) window.skScrollToEl(target, "center");
      else target.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }
})();
